var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rightBar", staticStyle: { color: "#fff" } },
    [
      _c("v-drawer", { attrs: { direction: "right", width: "26%" } }, [
        _c(
          "div",
          {
            staticClass: "animated fadeInRightBig",
            staticStyle: { height: "100%", width: "100%" },
          },
          [
            _c(
              "bar-card",
              { staticClass: "lefts lefts2 lefts4", attrs: { bg: "border2" } },
              [
                _c("v-title", [_vm._v("茂名品种规模分析")]),
                _c(
                  "div",
                  { staticClass: "panelContent" },
                  [_c("right-mid")],
                  1
                ),
              ],
              1
            ),
            _c(
              "bar-card",
              { staticClass: "lefts lefts4", attrs: { bg: "border2" } },
              [
                _c("v-title", [_vm._v("销区价格历年对比")]),
                _c("div", { staticClass: "panelContent" }, [_c("left-mid")], 1),
              ],
              1
            ),
            _c(
              "bar-card",
              { staticClass: "lefts lefts3 lefts4", attrs: { bg: "border2" } },
              [
                _c("v-title", [_vm._v("荔枝产地环境监测")]),
                _c(
                  "div",
                  { staticClass: "panelContent" },
                  [_c("right-bot")],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }